// extracted by mini-css-extract-plugin
module.exports = {"information":"AdministrationInfoWarning_information__3CCBi","hintIcon":"AdministrationInfoWarning_hintIcon__2zavp","tableText":"AdministrationInfoWarning_tableText__HGQRE"};